import React from "react";
import getDrakryggenLogoPicture from "../../genericFunctions/getDrakryggenLogoPicture";

const CvHeader = (props) => {
  const {
    managerInfoText,
    consultantTitle,
    phone,
    email,
    displayName,
    profilePictureSrc,
  } = props;

  return (
    <div style={{ backgroundColor: "#13222d", width: "100%" }}>
      <div
        style={{
          width: "100%",
          backgroundColor: "#13222d",
          padding: "20px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <img
          alt="Profile"
          src={profilePictureSrc}
          style={{
            objectFit: "cover",
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            boxShadow: "0px 1px 16px -4px rgba(0, 0, 0, 0.75)",
            border: "2px solid #13222d",
            position: "relative",
            top: "0",
            left: "0",
          }}
        />
        <div style={{ color: "white", marginLeft: "10px", minWidth: "40%" }}>
          <h2 style={{ marginBottom: "3px" }}>{displayName}</h2>
          <h4 style={{ margin: "0px", padding: "0px" }}>{consultantTitle}</h4>
          <p
            style={{
              fontWeight: "bold",
              marginBottom: "0px",
              paddingBottom: "0px",
            }}
          >
            {managerInfoText}
          </p>

          <p style={{ margin: "2px 0px", padding: "2px 0px" }}>
            <span style={{ fontSize: "15px" }}>&#x40;</span> {email}
          </p>
          <p style={{ marginTop: "0px", paddingTop: "0px" }}>
            <span style={{ fontSize: "15px" }}>&#9742;</span> {phone}
          </p>
        </div>

        <img
          alt="Company Logo"
          src={getDrakryggenLogoPicture()}
          style={{
            width: "150px",
            position: "absolute",
            right: "10px",
            top: "130px",
          }}
        />
      </div>
    </div>
  );
};

export default CvHeader;
